import { render, staticRenderFns } from "./MarketingCenterPage.vue?vue&type=template&id=78a8a176"
import script from "./MarketingCenterPage.vue?vue&type=script&lang=js"
export * from "./MarketingCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports